import React from "react";
import "./DateLowToHigh.scss";
import useDateLowToHigh from "../../../../../../hooks/useDateLowToHigh";

const DateLowToHigh = ({ data, role }) => {
  const { divideColumns, navigate } = useDateLowToHigh();
  return (
    <div className="DateLowToHigh-cont">
      {data && data.length ? (
        divideColumns(data).map((el) => {
          return (
            <div className="DateLowToHigh-cont__column" key={Math.random()}>
              {el}
            </div>
          );
        })
      ) : (
        <div className="emptyMyFeedback-cont">
          <p className="emptyMyFeedback-cont__text">
            You don't have any feedback yet
          </p>
        </div>
      )}
    </div>
  );
};

export default DateLowToHigh;
